import {findIndex, isArray} from 'lodash'
import {renameObjKey} from '@/helpers/HelperObject'
import Vue from 'vue'
import constants from '@/assets/js/constants'
import {mapWritableState} from 'pinia'
import {useUsersStore} from '@/stores/UsersStore'
import MixinGenericComponent from '@/mixins/generic/MixinGenericComponent'

export default {
    mixins: [MixinGenericComponent],
    computed: {
        ...mapWritableState(useUsersStore, {
            users: 'users',
            consolidatedUsersAndSubUsers: 'consolidatedUsersAndSubUsers',
        })
    },
    mounted() {
        // Because the watch of users is not fired on the first load
        this.configUserConsolidateUsersAndSubUsers()
    },
    watch: {
        users: {
            handler: function (newVal, oldVal) {
                this.configUserConsolidateUsersAndSubUsers()
            },
            deep: true
        }
    },
    methods: {

        configUserPrepareAnArrayForAutocompleteOfUserGroup() {

            let self = this

            let userGroups = []
            self.users?.forEach((userGroup) => userGroups.push(userGroup.key))

            return userGroups

        },

        prepareAnArrayForAutocompleteTopLevel(categories) {

            let allUsers = []

            categories.forEach(category => {
                category.value.forEach(user => {
                    !['@_internet', '@_categories_profile'].includes(user.key) ? allUsers.push(user.key) : ''
                })
            })

            return allUsers

        },

        prepareAnArrayForUserAutocompleteAlongWithUserGroup(categories) {

            let allUsers = []

            categories.forEach(category => {

                category.value.forEach(user => {

                    !['@_internet', '@_categories_profile'].includes(user.key) ? allUsers.push({
                        userKey: user.key,
                        userGroupKey: category.key
                    }) : ''

                })

            })

            return allUsers

        },

        configUserIsAValidUserKey(userKey) {

            let self = this

            let userIndex = false

            for (let categoryIndex = 0; categoryIndex < self.users.length; categoryIndex++) {
                if (categoryIndex !== -1) {

                    if (!userIndex) {
                        if (findIndex(self.users[categoryIndex]['value'], (val) => val.key === userKey) !== -1) {
                            userIndex = true
                        }
                    }
                }
            }

            return userIndex

        },
        updateUserGroupCategory(existingKey, newKey, newInternetOption, newCategoryProfileOption) {

            let self = this

            let itemIndex = findIndex(self.users, {key: existingKey})
            let atInternetIndex = findIndex(self.users[itemIndex]['value'], {key: '@_internet'})
            let atCategoryProfileIndex = findIndex(self.users[itemIndex]['value'], {key: '@_categories_profile'})

            if (itemIndex !== -1) {
                Vue.set(self.users[itemIndex], 'key', newKey)
                Vue.set(self.users[itemIndex]['value'][atInternetIndex], 'value', newInternetOption)
                Vue.set(self.users[itemIndex]['value'][atCategoryProfileIndex], 'value', newCategoryProfileOption)
            }

        },
        updateUserGroupProfile(oldProfileName, newProfileName) {

            let self = this

            self.users.forEach((userGroup) => {

                userGroup.value.forEach((category) => {

                    if (category.key === 'categories_profile' && category.value === oldProfileName) {
                        category.value = newProfileName
                    } else if (typeof category.value === 'object') {

                        for (let attr in category.value) {

                            if (attr === 'categories_profile' && category.value[attr] === oldProfileName) {
                                category.value[attr] = newProfileName;
                            }

                        }

                    }

                })

            })

        },

        configUserReplaceTheKeyWithOnTheUserLevel(categoryKey, newGroupKey, existingUserKey, newUserKey) {

            let self = this

            let categoryIndex = findIndex(self.users, {key: categoryKey})
            let newUserGroupIndex = findIndex(self.users, {key: newGroupKey})

            if (categoryIndex !== -1) {

                let userIndex = findIndex(self.users[categoryIndex]['value'], {key: existingUserKey})

                if (newUserGroupIndex !== -1 && categoryKey !== newGroupKey) {

                    // Remove user from old categoryIndex
                    self.users[newUserGroupIndex]['value'].push(self.users[categoryIndex]['value'][userIndex])
                    self.users[categoryIndex]['value'].splice(userIndex, 1)

                } else {
                    Vue.set(self.users[categoryIndex]['value'][userIndex], 'key', newUserKey)
                }
            }
        },

        /**
         *
         * @param parentCategoryKey
         * @param parentUserKey
         * @param device
         *
         * Expected as:
         *
         * {
         *      key: 'device-key',
         *      value: {
         *          active: 1|0,
         *          mac: '00:00:00:00:00:00',
         *      }
         * }
         *
         */
        addADeviceToDatabase(parentCategoryKey, parentUserKey, device) {

            let self = this

            let categoryIndex = findIndex(self.users, {key: parentCategoryKey})

            if (categoryIndex !== -1) {
                Vue.set(self.users[categoryIndex].value[parentUserKey]['devices'], device.key, device.value)
            }

        },
        addUserUnderCategoryToDatabase(parentCategoryKey, user) {

            let self = this

            let categoryIndex = findIndex(self.users, {key: parentCategoryKey})

            if (categoryIndex !== -1) {
                // Vue.set(self.users[categoryIndex].value, user.key, user.value);
                self.users[categoryIndex].value.push({
                    key: user.key,
                    value: user.value
                })
            }

        },

        getOptionsForUserGroupInternet() {
            
            // return this.$i18n.locale === 'en' ? constants.internetOptions : constants.internetOptionsFr

            let self = this
            
            if(self.$language.current === 'en_GB') {
                return constants.internetOptions
            } else if(self.$language.current === 'fr_FR') {
                return constants.internetOptionsFr
            } else if(self.$language.current === 'it_IT') {
                return constants.internetOptionsIt
            } else {
                return constants.internetOptionsFr
            }

        },

        addCategoryToDatabase(category) {

            let self = this
            self.users.push(category)

        },

        changeCategoryOfUser(oldGroupKey, newGroupKey, userKey) {

            if (oldGroupKey !== newGroupKey) {

                let self = this
                let tempUser = false

                let oldGroupIndex = findIndex(self.users, {key: oldGroupKey})

                tempUser = self.users[oldGroupIndex].value[userKey]

                if (tempUser) {

                    delete self.users[oldGroupIndex].value[userKey]
                    Vue.set(self.users[findIndex(self.users, {key: newGroupKey})].value, userKey, tempUser)
                }
            }
        },

        /**
         *
         * @param parentCategoryKey
         * @param parentUserKey
         * @param subUserName
         * @param subUser
         *
         */
        addSubUserUnderUser(parentCategoryKey, parentUserKey, subUserName, subUser) {

            let self = this

            let categoryIndex = findIndex(self.users, {key: parentCategoryKey})

            if (categoryIndex !== -1) {

                // Sometimes, this is not present, and throws the undefined error
                if (!self.users[categoryIndex].value[parentUserKey].hasOwnProperty('subusers')) {
                    self.users[categoryIndex].value[parentUserKey]['subusers'] = {}
                }

                Vue.set(self.users[categoryIndex].value[parentUserKey]['subusers'], subUserName, subUser)
            }

        },

        configUserDeleteUserChildNode(categoryKey, userKey, nodeKeyToDelete, nodeName) {

            let self = this

            let categoryIndex = findIndex(self.users, (val) => val.key === categoryKey)

            if (categoryIndex !== -1) {
                let userIndex = findIndex(self.users[categoryIndex]['value'], (val) => val.key === userKey)

                if (userIndex !== -1) {
                    let nodeIndex = findIndex(self.users[categoryIndex]['value'][userIndex]['value'][nodeName], (val) => val.key === nodeKeyToDelete)
                    if (nodeIndex !== -1) {
                        self.users[categoryIndex]['value'][userIndex]['value'][nodeName].splice(nodeIndex, 1)
                        return true
                    }
                }
            }

            return false

        },

        configUserAddUserChildNode(categoryKey, userKey, nodeKey, nodeName) {

            let self = this

            let categoryIndex = findIndex(self.users, (val) => val.key === categoryKey)

            if (categoryIndex !== -1) {
                let userIndex = findIndex(self.users[categoryIndex]['value'], (val) => val.key === userKey)

                if (userIndex !== -1) {

                    if (typeof self.users[categoryIndex]['value'][userIndex]['value'][nodeName] !== 'object') {
                        Vue.set(self.users[categoryIndex]['value'][userIndex]['value'], nodeName, [])
                    }

                    self.users[categoryIndex]['value'][userIndex]['value'][nodeName].push(nodeKey)
                    return true
                }
            }

            return false

        },

        configUserUpdateUserChildNode(categoryKey, userKey, nodeKeyToReplace, newNode, nodeName) {

            let self = this

            let categoryIndex = findIndex(self.users, (val) => val.key === categoryKey)

            if (categoryIndex !== -1) {
                let userIndex = findIndex(self.users[categoryIndex]['value'], (val) => val.key === userKey)

                if (userIndex !== -1) {
                    let nodeIndex = findIndex(self.users[categoryIndex]['value'][userIndex]['value'][nodeName], (val) => val.key === nodeKeyToReplace)
                    if (nodeIndex !== -1) {
                        Vue.set(self.users[categoryIndex]['value'][userIndex]['value'][nodeName], nodeIndex, newNode)
                        return true
                    }
                }
            }

            return false

        },
        /**
         * Yet to be tested. Consider this function as incomplete
         */
        configUserUpdateUserLevelNode(categoryKey, userKey, newNode) {

            let self = this

            let categoryIndex = findIndex(self.users, (val) => val.key === categoryKey)

            if (categoryIndex !== -1) {
                let userIndex = findIndex(self.users[categoryIndex]['value'], (val) => val.key === userKey)
                // self.users[categoryIndex]['value'][userIndex] = newNode
                Vue.set(self.users[categoryIndex]['value'], userIndex, newNode)
            }

            return false

        },

        /**
         *
         * @param userKey
         * @returns {boolean|string}
         */
        configUserGetUserGroupKeyByUserKey(userKey) {

            let self = this
            let userGroupKey = false

            self.users.forEach((userGroup) => {

                userGroup.value.forEach((user) => {
                    if (user.key === userKey) {
                        userGroupKey = userGroup.key
                    }
                })

            })

            return userGroupKey

        },

        configUserProcessUserChildNodeDelete(categoryKey, userKey, nodeKeyToDelete, nodeName, entityName, deleteFromRules = false) {

            const entityAndItem = {
                entity: entityName,
                item: nodeKeyToDelete
            }

            if (deleteFromRules) {

                this.rules.forEach((rule) => {
                    if (isArray(rule?.value?.users)) {
                        (rule.value.users.indexOf(nodeKeyToDelete) !== -1) ? rule.value.users.splice(rule.value.users.indexOf(nodeKeyToDelete), 1) : ''
                    }
                })

            }

            if (this.configUserDeleteUserChildNode(categoryKey, userKey, nodeKeyToDelete, nodeName)) {
                this.$refs.snackbar.showSnackbar(this.$gettextInterpolate(this.$gettext('The %{entity}, %{item} is deleted successfully!'), entityAndItem))
                return true
            } else {
                this.$refs.snackbar.showSnackbar(this.$gettextInterpolate(this.$gettext('Sorry! the %{entity} %{item} could not be deleted.'), entityAndItem), 'error')
            }

            return false

        },

        configUserProcessUpdateUserChildNode(categoryKey, userKey, nodeKeyToReplace, newNode, nodeName, entityName) {

            // $parent because the dialog is going to be closed next, the message won't show at all, should we do it in the same component.
            const entityAndItem = {
                'entity': entityName,
                'item': newNode.key
            }

            if (this.configUserUpdateUserChildNode(categoryKey, userKey, nodeKeyToReplace, newNode, nodeName)) {
                this.$parent.$refs.snackbar.showSnackbar(this.$gettextInterpolate(this.$gettext('%{entity} %{item} is updated successfully!'), entityAndItem))
                return true
            } else {
                this.$parent.$refs.snackbar.showSnackbar(this.$gettextInterpolate(this.$gettext('Sorry! the %{entity} %{item} could not be updated'), entityAndItem), 'error')
            }

            return false
        },

        configUserConsolidateUsersAndSubUsers() {

            let mergedUsers = []

            this.users?.forEach((category) => {

                category?.value?.forEach((user) => {

                    // to avoid the @_internet entry
                    if (typeof (user?.value) === 'object') {
                        mergedUsers.push(user?.key)

                        user?.value?.subusers?.forEach((subUser) => {
                            mergedUsers.push(subUser.key)
                        })
                    }

                })

            })

            // Otherwise we will have cylic dependency
            if (this.consolidatedUsersAndSubUsers !== mergedUsers) {
                Vue.set(this, 'consolidatedUsersAndSubUsers', mergedUsers)
            }

            return mergedUsers

        },

        configUserHasDeviceUnderUser(userKey, deviceName) {

            let self = this
            let found = false

            self.users.forEach((userGroup) => {

                userGroup.value.forEach((user) => {
                    if (user.key === userKey) {

                        if (user.value.hasOwnProperty('devices')) {
                            user.value.devices.forEach((device) => {

                                if (device.key === deviceName) {
                                    found = true
                                }

                            })
                        }
                    }
                })
            })

            return found

        },
        async configUserHasUserUnderUserGroup(userGroupKey, userKey) {

            let self = this
            let found = false

            await self.$nextTick() // Just to satisfy async method.

            self.users.forEach((userGroup) => {

                if (userGroup.key.toLowerCase() === userGroupKey.toLowerCase()) {

                    userGroup.value.forEach((user) => {
                        if (user.key.toLowerCase() === userKey.toLowerCase()) {
                            found = true
                        }
                    })

                }

            })

            return found

        },

        configUserIsDeviceUniqueForUser(deviceName, userGroupKey = false, userKey, deviceKeyException = false) {

            let self = this
            let found = false

            if (deviceName && deviceKeyException && deviceName === deviceKeyException) {
                return true
            }

            if (!userGroupKey) {
                userGroupKey = self.configUserGetUserGroupKeyByUserKey(userKey)
            }

            self.users.forEach((userGroup) => {

                if (userGroup.key.toLowerCase() === userGroupKey.toLowerCase()) {

                    userGroup.value.forEach((user) => {

                        if (user.key.toLowerCase() === userKey.toLowerCase()) {

                            user.value.devices.forEach((device) => {

                                if (device.key.toLowerCase() === deviceName.toLowerCase()) {
                                    found = true
                                }

                            })

                        }

                    })

                }

            })

            return !found

        },


        configUserGetCategoryAndUserIndex(uc, un) {

            let self = this;

            let userCategoryIndex = -1;
            let userIndex = -1;

            if (uc && un) {

                self.users.forEach((userCategory, index) => {
                    if (userCategory.key === uc) {
                        userCategoryIndex = index

                        userCategory.value.forEach((user, uIndex) => {
                            if (user.key === un) {
                                userIndex = uIndex;
                            }
                        })
                    }
                })

            }

            return {
                userIndex,
                userCategoryIndex
            }

        },

        configFindCategoryByKey(key) {
            return this.users.find(userCategory => userCategory.key === key) || null;
        },

        configGetCategoryIndexByKey(key) {
            return this.users.findIndex(userCategory => userCategory.key === key);
        },

        configGetCategoryByKey(key) {
            return this.configFindCategoryByKey(key);
        },


    }

}
